import { AfterViewInit, Directive, OnDestroy, Optional, Renderer2, Self } from "@angular/core";
import { AutoComplete } from "primeng/autocomplete";
import { Subscription } from "rxjs";

@Directive({
    selector: "p-autoComplete"
})
export class NoAutofocusDropdownSmDirective implements AfterViewInit, OnDestroy {
    private onDropdownClickSub: Subscription;
    private dropdownClicked = false;

    constructor(@Optional() @Self() private autocomplete: AutoComplete, private renderer: Renderer2) {}

    ngAfterViewInit(): void {
        if ((this.autocomplete && !this.autocomplete.dropdown) || this.input == null) {
            return;
        }

        this.onDropdownClickSub = this.autocomplete.onDropdownClick.subscribe(_ => this.onDropdownClicked());
        this.renderer.listen(this.input, "focus", () => this.onFocus());
    }

    ngOnDestroy(): void {
        this.onDropdownClickSub?.unsubscribe();
    }

    private onFocus() {
        if (window.innerWidth >= 576) {
            return;
        }

        if (this.dropdownClicked) {
            this.dropdownClicked = false;
            this.input.blur();
        }
    }

    private onDropdownClicked() {
        if (window.innerWidth >= 576) {
            return;
        }

        this.dropdownClicked = true;
        this.input.blur();
        this.autocomplete.overlayVisible = true;
    }

    private get input(): HTMLInputElement {
        return (this.autocomplete?.inputEL ?? this.autocomplete?.multiInputEl).nativeElement;
    }
}
